import React from 'react';
import { Helmet } from 'react-helmet';

const CookiePolicy: React.FC = () => {
  return (
    <div className="space-y-6">
      <Helmet>
        <title>Politica de cookies</title>
      </Helmet>

      <div className="space-y-2">
        <h1 className="text-2xl font-semibold">Politica de cookies</h1>
        <p className="text-sm text-muted-foreground">Ultima actualizare: 11 februarie 2026</p>
      </div>

      <section className="space-y-3 text-sm">
        <h2 className="text-lg font-semibold">1. Ce sunt cookie-urile</h2>
        <p className="text-muted-foreground">
          Cookie-urile sunt fișiere mici salvate pe dispozitivul tău, folosite pentru funcționarea corectă a site-ului și,
          după caz, pentru preferințe și măsurarea utilizării.
        </p>
      </section>

      <section className="space-y-3 text-sm">
        <h2 className="text-lg font-semibold">2. Ce folosim în Platformă</h2>
        <div className="space-y-3 text-muted-foreground">
          <p>
            Platforma folosește în principal tehnologii de stocare locală (de ex. <span className="text-foreground">localStorage</span>)
            pentru:
          </p>
          <ul className="list-disc pl-5 space-y-2">
            <li>preferința privind cookie-urile (accept/refuz);</li>
            <li>preferințe UI (unde este cazul);</li>
            <li>menținerea sesiunii (token de autentificare), în funcție de opțiunea „Ține-mă minte”.</li>
          </ul>
          <p>
            Folosim cookie-uri/tehnologii esențiale pentru funcționarea Platformei. Cookie-urile neesențiale (de ex.
            analytics/marketing) vor fi folosite doar dacă sunt activate și dacă utilizatorul își exprimă opțiunea (în
            funcție de implementare).
          </p>
        </div>
      </section>

      <section className="space-y-3 text-sm">
        <h2 className="text-lg font-semibold">3. Cum îți poți gestiona preferințele</h2>
        <p className="text-muted-foreground">
          Poți refuza sau accepta cookie-urile neesențiale din bannerul de cookies. În plus, poți șterge cookie-urile și
          datele de site din setările browserului tău.
        </p>
      </section>

      <section className="space-y-3 text-sm">
        <h2 className="text-lg font-semibold">4. Contact</h2>
        <p className="text-muted-foreground">
          Pentru întrebări despre cookie-uri, ne poți contacta la <span className="text-foreground">office@globallinknet.ro</span>.
        </p>
      </section>
    </div>
  );
};

export default CookiePolicy;

